<style type="text/css">
  label {
    margin-bottom: 1px !important;
    color: lightseagreen;
    font-size: small;
  }

  .compare-container {
    display: flex;
    justify-content: center;
    width: 480px;
  }

  .compare-column {
    width: 200px;
    margin: 10px;
  }

  .testscroll {
    width: 100%;
    height: 200px;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .bottom-border {
    border-bottom: 1px solid #D3D3D3;
    margin: 4px;
  }

  .bottom-margin {
    margin-bottom: 10px;
  }

  .editButton {
    margin: 10px;
  }
</style>

<div class="overlay" *ngIf="loading">
  <div class="spinner-wrapper">
    <app-spinner>
      <span style="font-size: 3em; color: #27AE61;"><i class="fal fa-atom-alt fa-spin"></i></span>
    </app-spinner>
  </div>
</div>

<form [formGroup]="requisitionEditForm">

  <div class="row">
    <div class="wraper" style="width: 100%;">
      <div class="row">
        <div class="col-12">
          <div>
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-4">
                    Requisition - {{test.Accession}}
                  </div>
                  <div class="col-8">
                    <div style="float:right" [hidden]="inEdit || isInterVenn">
                      <a (click)="editTest()" class="iconbutton" title="Edit">
                        <i class="far fa-edit"></i>
                      </a>
                    </div>
                    <div style="float:right" [hidden]="!inEdit">
                      <a (click)="saveEdit()" class="iconbutton" title="Save" [ngClass]="(requisitionEditForm.invalid || !requisitionEditForm.dirty) ? 'disabled' : ''">
                        <!---->
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                    <div style="float:right" [hidden]="!inEdit">
                      <a (click)="cancelEdit()" class="iconbutton" title="Cancel">
                        <i class="fa fa-times"></i>
                      </a>
                    </div>

                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-4">
                    <div *ngIf="!inEdit">
                      <label>Name: </label> {{test.PatientFirstName}} {{test.PatientLastName}}
                    </div>
                    <div *ngIf="inEdit" class="row">
                      <div class="col-3"><label>Name: </label></div>
                      <div class="col-4 inputstyle">
                        <div><input formControlName="firstName" id="firstName" type="text" focus="true" class="inputstyle" pInputText [value]="test.PatientFirstName" /></div>
                        <div *ngIf="requisitionEditForm.controls['firstName'].errors?.required" class="valdiation-message-small">
                          * Required
                        </div>
                        <div *ngIf="requisitionEditForm.controls['firstName'].errors?.nowhitespace" class="valdiation-message-small">
                          * Spaces are not allowed
                        </div>
                      </div>
                      <div class="col-5 inputstyle">
                        <div><input formControlName="lastName" id="lastName" type="text" focus="true" class="inputstyle" pInputText [value]="test.PatientLastName" /></div>
                        <div *ngIf="requisitionEditForm.controls['lastName'].errors?.required" class="valdiation-message-small">
                          * Required
                        </div>
                        <div *ngIf="requisitionEditForm.controls['lastName'].errors?.nowhitespace" class="valdiation-message-small">
                          * Spaces are not allowed
                        </div>
                      </div>
                    </div>
                    <div *ngIf="!inEdit">
                      <label>Birthdate: </label> {{test.PatientBirthdate | date:'shortDate'}}
                    </div>
                    <div *ngIf="inEdit" class="row">
                      <div class="col-3"><label>Birthdate:</label></div>
                      <div class="col-9">
                        <kendo-datepicker formControlName="birthDate" [style.width]="'140px'" [min]="minbdate" [max]="maxbdate"
                                          (afterValueChanged)="handleBirthDateChange($event)" [format]="'MM/dd/yyyy'">
                        </kendo-datepicker>
                        <div *ngIf="requisitionEditForm.controls['birthDate'].errors?.required" class="valdiation-message-small">
                          * Required
                        </div>
                        <div *ngIf="requisitionEditForm.controls['birthDate'].errors?.minBirthDate" class="valdiation-message-small">
                          * Birth date must be great than {{formattedminbdate}}
                        </div>
                        <div *ngIf="requisitionEditForm.controls['birthDate'].errors?.maxBirthDate" class="valdiation-message-small">
                          * Birth date must be less than {{formattedmaxbdate}}
                        </div>
                      </div>
                    </div>
                    <div *ngIf="!inEdit">
                      <label>Gender: </label> {{genderDescription}}
                    </div>
                    <div *ngIf="inEdit" class="row">
                      <div class="col-12">
                        <div class="row">
                          <div class="inputlabel col-3"><label>Gender:</label></div>
                          <div class="col-8" style="margin-top:10px">
                            <kendo-dropdownlist formControlName="gender" [valuePrimitive]="true" [value]="test.PatientGender" style="width:100%"
                                                [data]="genderList" [valueField]="'Code'" [textField]="'Description'">
                            </kendo-dropdownlist>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div *ngIf="!inEdit">
                      <label>Ethnicity:</label>  {{ethnicityDescription}}
                    </div>
                    <div *ngIf="inEdit" class="row">
                      <div class="inputlabel col-3"><label>Ethnicity:</label></div>
                      <div class="col-8" style="margin-top:10px; margin-bottom: 10px">
                        <kendo-dropdownlist formControlName="ethnicity" [valuePrimitive]="true" [value]="test.PatientEthnicity" style="width:100%"
                                            [data]="ethnicityList" [valueField]="'Code'" [textField]="'Description'">
                        </kendo-dropdownlist>
                      </div>
                    </div>
                    <div *ngIf="!inEdit">
                      <label>MRN: </label> {{test.PatientMRN}}
                    </div>
                    <div *ngIf="inEdit" class="row">
                      <div class="col-3"><label>MRN: </label></div>
                      <div class="col-9 inputstyle">
                        <div><input formControlName="mrn" id="mrn" type="text" focus="true" class="inputstyle" pInputText [value]="test.PatientMRN" /></div>
                      </div>
                    </div>
                    <div *ngIf="inEdit" class="row">
                      <div class="col-3"><label>Comment: </label></div>
                      <div class="col-9 inputstyle">
                        <div><textarea formControlName="comment" id="comment" type="text" focus="true" class="inputstyle" pInputTextArea [value]="test.EditComment"></textarea></div>
                        <div *ngIf="requisitionEditForm.controls['comment'].errors?.required" class="valdiation-message-small">
                          * Required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div>
                      <label>Client: </label> {{test.ClientName}}
                    </div>
                    <div>
                      <label>Facility: </label> {{test.FacilityCode}} - {{test.FacilityName}}
                    </div>
                    <div>
                      <label>Provider: </label> {{test.ProviderName}}
                    </div>
                  </div>
                  <div class="col-4">
                    <div>
                      <label>Test: </label> {{test.TestName}}
                    </div>
                    <div>
                      <label>Specimen Type: </label> {{test.SpecimenType}}
                    </div>
                    <div>
                      <label>Collected: </label> {{test.CollectedDate | date:'short'}}
                    </div>
                    <div>
                      <label>Received: </label> {{test.ReceivedDate | date:'short'}}
                    </div>
                    <div *ngIf="test.RequisitionTestResultId != null">
                      <div *ngFor="let result of test.results" class="row">
                        <div class="col-12 mb-2" *ngIf="result.RequisitionTestResultId == test.RequisitionTestResultId">
                          <label>Current Result: </label> <a class="mr-2" style="cursor: pointer; margin-left:5px;" (click)="getRequisitionTestResultReport(result.RequisitionTestResultId)">{{result.ResultText}}</a> <small>{{result.ReceivedFromLIMSDate | date:'short'}}</small>
                          <a [hidden]="!isInterVenn" (click)="setResultComment(result.Id, result.CorrectionReason)" class="iconbutton ml-2" title="Edit Result Comment">
                            <i class="far fa-edit"></i>
                          </a>
                        </div>
                        <div class="col-12" *ngIf="result.RequisitionTestResultId != test.RequisitionTestResultId">
                          <label>Previous Result: </label> <a class="mr-2" style="cursor: pointer; margin-left:5px;" (click)="getRequisitionTestResultReport(result.RequisitionTestResultId)">{{result.ResultText}}</a> <small>{{result.ReceivedFromLIMSDate | date:'short'}}</small>
                          <a [hidden]="!isInterVenn" (click)="setResultComment(result.Id, result.CorrectionReason)" class="iconbutton ml-2" title="Edit Result Comment">
                            <i class="far fa-edit"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>
      </div>
    </div>
  </div>
</form>
<div style="height: 600px; width: 100%" *ngIf="pdfView != null">
  <iframe style="height: 100%; width: 100%" [src]="pdfView"></iframe>

</div>
<p-dialog [(visible)]="showResultComment" [modal]="true">
  <ng-template #header>
    Result Comment
  </ng-template>
  <div style="height: 100px;">
    <textarea [(ngModel)]="resultComment" size="30" [style]="{'width':'400px'}"></textarea>
  </div>
  <ng-template #footer>
    <button (click)="showResultComment = false;" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-times"></i> Cancel
    </button>
    <button (click)="saveResultComment()" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-save"></i> Save
    </button>
  </ng-template>
</p-dialog>

<p-toast></p-toast>

